<template>
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-header-title">
          {{ $t('Bills') }}
        </h4>
        <router-link
          class="btn btn-sm btn-primary"
          :to="'/bills/create?customer_id=' + $route.params.id"
          v-if="$parent.item.stat == 1 && $checkRole('bills_add')"
        >
          <i class="fas fa-plus"></i>
          {{ $t('Addition') }}
        </router-link>
      </div>
      <indexTable
        :searchText="$parent.$t('searchForABill')"
        :withoutCard="true"
        :emptyTableText="$parent.$t('There are no bills')"
        :filter="{ customer_id: $route.params.id }"
        :emptyTableSubText="$parent.$t('Try adding some items to the table and try again')"
        :statusSearch="true"
        :statusValues="[
          {
            title: $parent.$t('Situation'),
            value: ''
          },
          { title: $parent.$t('All'), value: '' },
          { title: $parent.$t('Open'), value: 0 },
          { title: $parent.$t('Driven'), value: 1 },
          { title: $parent.$t('Canceled'), value: 2 }
        ]"
        :cloumns="[
          {
            column: 'code',
            title: $parent.$t('Bill'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'date',
            title: $parent.$t('The date of the invoice'),
            type: 'text',
            sort: true
          },
          {
            column: 'client_type',
            title: $parent.$t('Supplier name'),
            type: 'clintLink',
            sort: true
          },
          {
            column: 'total',
            title: $parent.$t('Cost'),
            type: 'text',
            sort: true
          },
          {
            column: 'rest',
            title: $parent.$t('Balance'),
            type: 'text',
            sort: true
          },
          {
            column: 'status',
            title: $parent.$t('Situation'),
            type: 'status',
            sort: true,
            values: [
              {
                title: $parent.$t('Open'),
                value: 0,
                color: 'dark'
              },
              {
                title: $parent.$t('Driven'),
                value: 1,
                color: 'success'
              },
              {
                title: $parent.$t('Canceled'),
                value: 2,
                color: 'danger'
              }
            ]
          },
          {
            column: 'options',
            title: $parent.$t('Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role: $checkRole('bills_edit')
              },
              { name: 'outLink', role: true },
              { name: 'printBill', role: true },
              { name: 'download', role: true },
              {
                name: 'delete',
                role: $checkRole('bills_delete')
              }
            ]
          }
        ]"
        :deleteText="{
          attention: $parent.$t('Attention'),
          areYouReallySureToDeleteTheItem: $parent.$t('Are you really sure to delete the item'),
          close: $parent.$t('Close'),
          confirm: $parent.$t('Confirm'),
          loading: $parent.$t('Loading')
        }"
      />
    </div>
  </div>
</template>
<script>
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/bills'
    }
  },
  components: {
    indexTable
  }
}
</script>
